import { render } from "./FolderGrid.vue?vue&type=template&id=48e2a93a&scoped=true&ts=true"
import script from "./FolderGrid.vue?vue&type=script&lang=ts"
export * from "./FolderGrid.vue?vue&type=script&lang=ts"

import "./FolderGrid.vue?vue&type=style&index=0&id=48e2a93a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e2a93a"]])

export default __exports__